import { render } from "./RecentRecords.vue?vue&type=template&id=15c02573&scoped=true&ts=true"
import script from "./RecentRecords.vue?vue&type=script&lang=ts"
export * from "./RecentRecords.vue?vue&type=script&lang=ts"

import "./RecentRecords.vue?vue&type=style&index=0&id=15c02573&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c02573"]])

export default __exports__